import { PreparationTime } from './preparation-time';
import { SpeakingTime } from './speaking-time';
import { SpeakingMaxAttempts } from './speaking-max-attempts';
import { SpeakingMinAnswerDuration } from './speaking-min-answer-duration';
import { TimeUnit } from '../time-unit';
/**
 * Raw settings kept by {@link SpeakingQuestion}. Time values retain their
 * original unit until a boundary (JSON/API) explicitly requires seconds.
 */

export var DEFAULT_SPEAKING_SETTINGS = {
  preparationTime: PreparationTime["default"].value,
  preparationTimeUnit: TimeUnit.Second,
  speakingTime: SpeakingTime["default"].value,
  speakingTimeUnit: TimeUnit.Second,
  maxAttempts: SpeakingMaxAttempts.Default,
  minAnswerDuration: SpeakingMinAnswerDuration.Unlimited,
  minAnswerDurationUnit: TimeUnit.Second
};